import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { Inquiry } from '@/services/faq/faq.types';
import { getColumns } from './Column';

export function InquriesTable({
  data,
  pagination,
  loading,
}: {
  data: Inquiry[];
  pagination: Pagination;
  loading: boolean;
}) {
  const { t } = useDynamicLocale();
  const { openConfirmation } = useConfirmationStore();
  const columns = React.useMemo(() => getColumns(t, openConfirmation), [t, openConfirmation]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table } = useDataTable({
    data: data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'sn', desc: true }],
    },
    meta: {
      title: <Translation id="faq.inquiry.table.title" />,
      totalPage: pagination.totalItems,
      loading: loading,
    },
    getRowId: (originalRow) => String(originalRow.sn),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table} className="font-medium">
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
